import PublicIcon from '@mui/icons-material/Public';
import { Button, Stack } from '@mui/material';

import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleContent,
} from '@/components/shared/toggle-button-group';
import { EligibleResourceType } from '@/data/subsidy/policies/interfaces';
import { StepTitle } from '@/packages/subsidy/pages/refund-request/steps/resource-description/components/step-title';
import type { RefundRequestWizardProps } from '@/packages/subsidy/pages/refund-request/steps/resource-description/interfaces';
import { useRefundRequestNavigation } from '@/packages/subsidy/pages/refund-request/steps/resource-description/navigation/use-navigation';
import { RefundRequestWizardStepIds } from '@/packages/subsidy/pages/refund-request/steps/resource-description/steps/step-ids';

const stepId = RefundRequestWizardStepIds.ItemSource;

type ItemSourceValue = RefundRequestWizardProps[typeof stepId];

export const ItemSource = () => {
  const { canGoBack, handleBack, handleNext, values } =
    useRefundRequestNavigation({
      stepId,
    });

  const currentValue = values[stepId];

  const handleOnChange = (value: ItemSourceValue) => {
    const updatedValues: Partial<RefundRequestWizardProps> = {
      [stepId]: value,
    };

    if (value !== currentValue) {
      updatedValues[RefundRequestWizardStepIds.ExternalItemForm] = {
        course: null,
        learningAid: null,
      };
    }

    handleNext(updatedValues);
  };

  return (
    <Stack gap={2} alignItems="flex-start" flex={1}>
      <StepTitle id="item-source-label">Onde você encontrou o item?</StepTitle>
      <ToggleButtonGroup<ItemSourceValue>
        aria-labelledby="item-source-label"
        value={values[stepId]}
        onChange={handleOnChange}
        direction={{ md: 'row' }}
        sx={{ width: { sm: '100%', md: '50%' } }}
      >
        <ToggleButton value={EligibleResourceType.Catalog}>
          <ToggleContent
            icon="galena-favicon-outlined"
            title="Aqui, na plataforma Galena"
          />
        </ToggleButton>
        <ToggleButton value={EligibleResourceType.ThreeSixty}>
          <ToggleContent
            icon={<PublicIcon sx={{ fontSize: 32, color: 'primary.dark' }} />}
            title="Fora da plataforma Galena"
          />
        </ToggleButton>
      </ToggleButtonGroup>
      {canGoBack && <Button onClick={handleBack}>Voltar</Button>}
    </Stack>
  );
};
